/**
 * Premium marquee running text (CSS-only animation).
 * items: array of strings; separator: symbol between repeats.
 */
export const Marquee = ({
  items = [],
  separator = "✦",
  className = "",
  textClass = "",
}) => {
  const content = items.flatMap((t, i) => [
    <span key={`t-${i}`} className="px-6">
      {t}
    </span>,
    <span key={`s-${i}`} className="opacity-40">
      {separator}
    </span>,
  ]);

  return (
    <div className={`marquee py-5 ${className}`}>
      <div className={`marquee-track ${textClass}`}>
        <div className="flex items-center">{content}</div>
        <div className="flex items-center" aria-hidden="true">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
